import { declareString } from "@1js/localization";

export const MainTitle = declareString("promptLibrary.mainTitle", {
  text: "Prompts to try",
  comment:
    "Title that appears on landing page for Copilot Lab. This string is located at the very top of the Copilot Lab landing page. 'prompts' is the text input provided to AI model like GPT",
});

export const MainTitleV2 = declareString("promptLibrary.mainTitleV2", {
  text: "Copilot Prompt Gallery",
  comment:
    "Title that appears on landing page for Copilot Lab. This string is located at the very top of the Copilot Lab landing page. 'prompts' is the text input provided to AI model like GPT",
});

export const MainTitleTeamTab = declareString(
  "promptLibrary.mainTitleTeamTab",
  {
    text: "Prompts",
    comment:
      "Title that appears on landing page for Copilot Lab. This string is located at the very top of the Copilot Lab landing page. 'prompts' is the text input provided to AI model like GPT",
  }
);

export const MainSubtitleUnlicensed = declareString(
  "promptLibrary.mainSubtitleUnlicensed",
  {
    text: "Explore prompts to create, edit, and get more done.",
    comment:
      "Subheading that appears below title on landing page for Copilot Lab. 'prompts' is the text input provided to AI model like GPT",
  }
);

export const AppLinkText = declareString("promptLibrary.appLinkText", {
  text: "Explore prompts in the Copilot Prompt Gallery app",
  comment: "Text on a link that navigates user to Copilot Prompt Gallery app",
});

export const AppLinkUnauthInfoMessage = declareString(
  "promptLibrary.appLinkUnauthInfoMessage",
  {
    text: "The Copilot Prompt Gallery app is only available to those with an Azure Active Directory account.",
    comment:
      "Text that appears in info label next to AppLinkText when not signed in",
  }
);
